import { gql, useQuery } from "@apollo/client";

type UserType = {
  id: number;
  login: string;
  balance: number;
};

const USER_QUERY = gql`
  query LoadUser {
    user {
      id
      login
      balance
    }
  }
`;

const useUser = (): [UserType | null, { refetch: () => void }] => {
  const { data, refetch } = useQuery<{ user: UserType }>(USER_QUERY, {
    pollInterval: 10000,
  });
  return [data && data.user ? data.user : null, { refetch: () => refetch() }];
};

export default useUser;
